import { getPartition, updatePartition } from '../../../NonReact/common/API/EntityAPIClient'
import { JSONResponse } from '../../../NonReact/common/Types/Types'
import { PartitionAdminDTO } from '../../../NonReact/Types/Types'
import { isVarNotEmpty } from '../../../NonReact/utils/GlobalFunctions'

/**
 * Update a partition with only the fields provided in partitionUpdate
 *
 * @param telSysID - Telephone System ID
 * @param partitionID - Partition ID
 * @param partitionUpdate - Partial object containing fields to update
 */
export const updatePartitionFromPartial = (
    telSysID: string | number,
    partitionID: string | number,
    partitionUpdate: Partial<PartitionAdminDTO>
): Promise<JSONResponse<PartitionAdminDTO>> =>
    getPartition(telSysID, partitionID).then(
        (partition: JSONResponse<PartitionAdminDTO>): Promise<JSONResponse<PartitionAdminDTO>> =>
            isVarNotEmpty(partition)
                ? updatePartition(telSysID, partitionID, { ...partition, ...partitionUpdate })
                : Promise.reject()
    )
